import { useFormik } from 'formik'
import React from 'react'
import toast from 'react-hot-toast'
import { BsChevronLeft } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { useValidateCodeMutation } from '../../../features/auth/passwordSlice'

interface ICodeFromEmail {
  email: string
  setStep: React.Dispatch<React.SetStateAction<'email' | 'code' | 'password'>>
  setCode: React.Dispatch<React.SetStateAction<number | null>>
}

export const CodeFromEmail = ({ email, setCode, setStep }: ICodeFromEmail) => {
  const [validateCode, { isLoading, isError, error }] =
    useValidateCodeMutation()

  const formik = useFormik({
    initialValues: {
      code: null,
    },
    // validationSchema: LoginSchema,
    onSubmit: async (values) => {
      try {
        toast.loading('Verifying...')
        await validateCode({
          email,
          code: values.code,
        }).unwrap()
        toast.dismiss()
        toast.success('Code is verified!')
        setCode(values.code)
        setStep('password')
      } catch (error: any) {
        console.log(error)
        toast.dismiss()
        toast.error(error?.data.message)
      }
    },
  })

  return (
    <div className='bg-white w-full max-w-[400px] rounded-md shadow-lg px-5 py-10'>
      <h3 className='text-2xl text-indigo-500 font-semibold text-center'>
        Gcbuying
      </h3>
      <h4 className='text-lg font-[500] text-slate-600 mt-8'>
        Enter 6-digit code 📩
      </h4>
      <p className='text-sm text-slate-500 mt-1'>
        Check your email. Enter the code you received via this email:{' '}
        <span className='font-semibold'>{email}</span>
      </p>

      <form action='' className='mt-6' onSubmit={formik.handleSubmit}>
        <div className='flex flex-col gap-1'>
          <label htmlFor='code' className='text-xs text-slate-600'>
            Code
          </label>
          <input
            type='number'
            name='code'
            id='code'
            value={formik.values.code || ''}
            onChange={formik.handleChange}
            placeholder=''
            className='transition-all duration-200 px-4 py-2 rounded-md text-sm border border-slate-300 focus:outline-none focus:ring-1 focus:ring-indigo-500 spin-button-none'
          />
          <p className='text-red-500 text-xs'>
            {formik.touched.code &&
              Boolean(formik.errors.code) &&
              formik.errors.code}
          </p>
        </div>

        <button
          type='submit'
          className='mt-4 transition-all duration-200 w-full py-2 text-sm rounded-md text-white font-semibold bg-indigo-500 hover:brightness-105'
        >
          Verify
        </button>

        <button
          type='button'
          onClick={() => setStep('email')}
          className='text-sm text-indigo-500 flex items-center mt-4 gap-2'
        >
          <BsChevronLeft className='text-md text-indigo-500' /> Back
        </button>
      </form>
    </div>
  )
}
